import { 
  collection, 
  addDoc, 
  getDocs,
  getDoc,
  doc,
  query,
  where,
  orderBy,
  Timestamp
} from 'firebase/firestore';
import { db } from '../config/firebase';
import type { Fragebogen } from '../types/quotes';

export const fragebogenService = {
  /**
   * Create a new fragebogen in Firestore
   * @param fragebogenData Fragebogen data without id and submittedAt
   * @returns Fragebogen ID
   */
  async createFragebogen(fragebogenData: Omit<Fragebogen, 'id' | 'submittedAt'>): Promise<string> {
    const docRef = await addDoc(collection(db, 'fragebogen'), {
      ...fragebogenData,
      submittedAt: Timestamp.now()
    });
    
    console.log('✅ Fragebogen created with ID:', docRef.id);
    return docRef.id;
  },

  /**
   * Get fragebogen by quote ID
   * @param quoteId Quote ID
   * @returns Fragebogen or null if not found
   */
  async getFragebogenByQuote(quoteId: string): Promise<Fragebogen | null> {
    const q = query(
      collection(db, 'fragebogen'),
      where('quoteId', '==', quoteId)
    );
    
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      return null;
    }
    
    const doc = snapshot.docs[0];
    const data = doc.data();
    
    return {
      id: doc.id,
      ...data,
      submittedAt: data.submittedAt?.toDate() || new Date()
    } as Fragebogen;
  },

  /**
   * Get fragebogen by ID
   * @param fragebogenId Fragebogen ID
   * @returns Fragebogen or null if not found
   */
  async getFragebogen(fragebogenId: string): Promise<Fragebogen | null> {
    const docRef = doc(db, 'fragebogen', fragebogenId);
    const docSnap = await getDoc(docRef);
    
    if (!docSnap.exists()) {
      return null;
    }
    
    const data = docSnap.data();
    return {
      id: docSnap.id,
      ...data,
      submittedAt: data.submittedAt?.toDate() || new Date()
    } as Fragebogen;
  },

  /**
   * List all fragebogen (admin only)
   * @returns Array of Fragebogen
   */
  async listFragebogen(): Promise<Fragebogen[]> {
    const q = query(
      collection(db, 'fragebogen'),
      orderBy('submittedAt', 'desc')
    );
    
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        submittedAt: data.submittedAt?.toDate() || new Date()
      } as Fragebogen;
    });
  }
};

